import { render, staticRenderFns } from "./templatePreview.vue?vue&type=template&id=20e04fa4&"
import script from "./templatePreview.vue?vue&type=script&lang=js&"
export * from "./templatePreview.vue?vue&type=script&lang=js&"
import style0 from "./templatePreview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports